import { IAutomationAppComponent } from "../../types";
import { schema} from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { FaRegLightbulb } from 'react-icons/fa'
import { OperationState } from "../OperationState";
import InsightsPanel from "./InsightsPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: FaRegLightbulb,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsPanel,
    createConfig: {
        group: 'RoomAutomation',
        name: "Light",
        description: "Light",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}

